import { Injectable } from '@angular/core';
import { AuthService } from "./auth.service";
import { clearInterval } from "node:timers";
import { SupabaseService } from "./supabase.service";
import { ModalBehavior, ModalsService } from "../../../../common/src/lib/services/modals.service";

import {
  ConfirmationDialog
} from "../../../../common/src/lib/modals/confirmation-dialog/confirmation-dialog.component";
import { combineLatest, timer } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PingService {

  interval?: NodeJS.Timeout;
  dialogOpen = false;

  constructor(
      private authService: AuthService,
      private window: Window,
      private supabaseService: SupabaseService,
      private modalsService: ModalsService,
  ) {}

  init() {
    // Configured to ping every 2 minutes
    const period = 120000;
    combineLatest([this.authService.user$, timer(0, period)]).subscribe(async user => {
      if(user && !this.dialogOpen) {
        const success = await this.ping();
        if(!success) {
          this.showDialog();
        }
      }
    });
  }

  async ping() {
    try {
      const res = await this.supabaseService.edgeFunc<boolean>('ping');
      return res;
    } catch (e) {
      return false;
    }
  }

  showDialog() {
    this.dialogOpen = true;
    this.modalsService.open(ConfirmationDialog, {
      disableClose: true,
      behavior: ModalBehavior.Dialog,
      data: {
        title: 'Connection lost',
        message: 'Connection to the servers was lost, Reload the page to continue',
        actionTitle: 'Reload',
        actionColor: 'primary',
        showCancelButton: false,
        action: () => {
          this.window.location.reload();
        }
      }
    });
  }

}
